<cft-accordion *ngTemplateOutlet="elements"></cft-accordion>

<ng-template #elements>
  <ng-content select="cft-accordion-element"></ng-content>
</ng-template>

@if (getStructuredData$() | async; as json) {
  <bgo-json-ld [json]="json"></bgo-json-ld>
}
